import { render, staticRenderFns } from "./CellRendererOrder.vue?vue&type=template&id=fd048e82"
import script from "./CellRendererOrder.vue?vue&type=script&lang=js"
export * from "./CellRendererOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports